module.exports = __webpack_public_path__ + "static/media/20.f3d855f1.svg";